import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { ESlice } from '@enums/redux.enum';

type InitialState = {
	flightNumber?: string;
	token?: string;
	isAuthenticated: boolean;
	error?: string;
	isLoading: boolean;
};

const initialState: InitialState = {
	flightNumber: undefined,
	token: undefined,
	isAuthenticated: false,
	error: undefined,
	isLoading: false,
};

const authSlice = createSlice({
	name: ESlice.auth,
	initialState,
	reducers: {
		setToken: (state, { payload }: PayloadAction<string | undefined>) => {
			state.token = payload;
			state.error = undefined;
		},
		setFlightNumber: (state, { payload }: PayloadAction<string>) => {
			state.flightNumber = payload;
			if (state.token && state.flightNumber) {
				state.isAuthenticated = true;
			}
			state.error = undefined;
		},
		reset: (state) => {
			state.flightNumber = undefined;
			state.isAuthenticated = false;
			state.error = undefined;
			state.isLoading = false;
		},
		setError: (state, { payload }: PayloadAction<string | undefined>) => {
			state.error = payload;
			state.isLoading = false;
		},
		setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
			state.isLoading = payload;
		},
	},
});

export const { setToken, setFlightNumber, reset, setError, setIsLoading } = authSlice.actions;

export default authSlice.reducer;
